export const REQUEST = 'CATEGORIES/REQUEST';
export const RECEIVE = 'CATEGORIES/RECEIVE';